import { BaseFeedbackConIcona } from 'feedback'
import { ICONE } from 'icons'
import { BaseGridLayout, BaseHeaderConIcona } from 'layout'
import { BaseGrassetto } from 'text'
import { formattaDataEOra } from 'utils'
import DownloadFile from '../../../util/DownloadFile'
import IconaModificheBloccatePrimaDiData from '../../entitaGenerica/components/IconaModificheBloccatePrimaDiData'
import { isDocumentoGeneratoDaTemplate, creaDescrizioneDocumentoAllegato } from '../utilDocumenti'

export default function HeaderDocumentoAllegato(props) {
  const {
    documento,
    trovaTemplateConNome,
    gridProps,
    renderContenutoCustom,
    isDataDaCongelare,
    propsHeader: propsHeader_PassateDaFuori,
    propsDownloadFile,
    ...restProps
  } = props

  const isGenerato = isDocumentoGeneratoDaTemplate(documento)
  const propsHeader = isGenerato ? {
    icona: <ICONE.TEMPLATE_DOCUMENTO />,
    coloreIcona: 'warning.light',
    ...(trovaTemplateConNome && {
      sottotitolo: `Modello: ${trovaTemplateConNome(documento.template)?.descr || documento.template}`
    }),
    ...propsHeader_PassateDaFuori
  } : {
    icona: <ICONE.ALLEGATO />,
    sottotitolo: 'Caricato dall\'utente',
    ...propsHeader_PassateDaFuori
  }

  function isDocumentoDaCongelare() {
    return documento.protocollazione || documento.visto || isDataDaCongelare?.(documento.dataAggiornamento)
  }

  return (
    <BaseGridLayout alignCenter noWrap spacing={1} {...gridProps}>
      <BaseHeaderConIcona
        titolo={creaDescrizioneDocumentoAllegato(documento)}
        {...propsHeader}
        sottotitolo={
          <>
            {propsHeader.sottotitolo}
            {documento.dataAggiornamento &&
              <>
                {propsHeader.sottotitolo && <br />}
                Ultima modifica: {formattaDataEOra(documento.dataAggiornamento)}

                {isDocumentoDaCongelare() &&
                  <>
                    <IconaModificheBloccatePrimaDiData
                      descrOggetto='documenti con ultima modifica precedente al'
                      sx={{ py: 0, m: 0 }}
                      {...(documento.visto && {
                        descrOggetto: '"Visto" in data',
                        data: documento.visto.data,
                        descrData: '',
                      })}
                      {...(documento.protocollazione && {
                        descrOggetto: 'protocollazione in data',
                        data: documento.protocollazione.data,
                        descrData: '',
                        formattaDataSenzaOra: true
                      })}
                    />
                    {documento.protocollazione &&
                      <BaseGrassetto sx={{ color: 'green' }}>
                        Prot. {documento.protocollazione.numero} / {documento.protocollazione.anno}
                      </BaseGrassetto>
                    }
                  </>
                }
              </>
            }
          </>
        }
        {...restProps}
      />

      {documento.isBozza ? (
        <BaseFeedbackConIcona.Info messaggio='Bozza' />
      ) : (
        <DownloadFile
          file={documento.allegato}
          nascondiIconaFormatoFile
          nascondiNomeFile
          mostraBottoneVisualizzaFile
          gridProps={{ spacing: 0 }}
          {...propsDownloadFile}
        />
      )}

      {renderContenutoCustom?.({ documento, isGenerato })}
    </BaseGridLayout>
  )
}